module.exports = __webpack_public_path__ + "Roboto-BlackItalic.38d14dd4ff163c34e45b.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-BlackItalic.woff2
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-BlackItalic.woff2
// module chunks = styles